import * as React from "react";
const SvgProjectInformation = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "project_information_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "project_information_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 .5A11.5 11.5 0 1 0 23.5 12 11.51 11.51 0 0 0 12 .5m0 21a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m12.05 9.11-2 1a1 1 0 0 0 .86 1.8l-1.37 4.82a1 1 0 0 0 .69 1.27.8.8 0 0 0 .27 0 1 1 0 0 0 1-.73l2-7a1 1 0 0 0-1.41-1.16ZM14.2 6.29a1 1 0 0 0-1.63.32 1.1 1.1 0 0 0-.07.39 1 1 0 0 0 .29.7 1 1 0 0 0 1.09.22.9.9 0 0 0 .32-.22 1 1 0 0 0 .3-.7 1.1 1.1 0 0 0-.08-.39.9.9 0 0 0-.22-.32",
	style: { fill: "currentColor" }
}))));
export default SvgProjectInformation;
